import { createFileRoute, redirect } from '@tanstack/react-router'

import { getFirstSuperUserSetupStatusHandler } from '@/features/Auth/FirstSuperUser/server.ts'
import AuthLayout from '@/layouts/AuthLayout'
import { systemSettingsQueryOptions } from '@/lib/Queries/appQueries.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_public')({
    component: LayoutComponent,
    errorComponent: RouteErrorComponent,
    beforeLoad: async function ({ location }) {
        const { isRequired } = await getFirstSuperUserSetupStatusHandler()

        if (isRequired && location.pathname !== '/setup') {
            throw redirect({ to: '/setup' })
        }

        if (!isRequired && location.pathname === '/setup') {
            throw redirect({ to: '/login' })
        }
    },
    loader: async function ({ context }) {
        await context.queryClient.ensureQueryData(systemSettingsQueryOptions())
    },
})

function LayoutComponent() {
    return <AuthLayout />
}
